export default __webpack_public_path__ + "static/media/money_icon.b3d184d1.svg";